<template>
    <b-col cols="10" offset-md="2">
      <b-alert :show="showErrorAlta" dismissible @dismissed="showErrorAlta=false" variant="danger">Error al dar de alta la base {{model.schema_name}}: {{response.msg}}</b-alert>
      <b-alert :show="showOkAlta" dismissible @dismissed="showOkAlta=false" variant="success">La base {{model.schema_name}} se dio de alta correctamente.</b-alert>
      <b-row class="justify-content-center">
        <b-card title="Reestablecer clave usuario Mobile" class="w-100 mt-4 p-3">
          <b-overlay
            :show="loading"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-large
            rounded="sm"
          >
            <b-form id="formID" @submit.prevent="onSubmit" method="POST" class="form-row needs-validation" ref="formID">
              
            
              <div class="w-100"></div>

              <div class="w-100"></div>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="Email">Email</label>
                <b-form-input id="solicitante" v-model="model.email" placeholder="Ingresa email del solicitante" required></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="evento_descrip">CompanyId</label>
                <b-form-input id="evento_descrip" v-model="model.companyid" placeholder="Ingresa el CompanyId" required></b-form-input>
              </b-form-group>

              <div class="w-100"></div>
              
              <div class="w-100">
              </div>
      
              
              <b-button type="submit" size="lg" variant="outline-primary">Enviar</b-button>

            </b-form>   
          </b-overlay>

        </b-card >
      </b-row>
      
    </b-col>

</template>

<script>
import {TokenService} from "./../storage/service"

export default {
  name: 'ResetPassword',
  props: {
    msg: String
  },
  data: function () {
    return {
      pisar_base: false,
      showErrorAlta: false,
      showOkAlta: false,
      loading: false,
      modelos: [], //traera de api de forma dinamica
      sistemas: ['UNICA', 'CAMPO', 'CONT', 'PACKING'],
      servidores: [], //traer de API
      tar_list: [], //traer de API
      file_list: [], //traer de API
      versiones: ['2', '5', '6', '7'], //traer de API
      zonas: [], //Traer de API
      empresa: ['TS', 'SISTEC'],
      db_tipo_id: [], // traer de API 
      aplicacion_tipos: [], //TRAER de api
      schemaname_isvalid: null,
      schemaname_msg: "",
      descripcion_isvalid: null,
      descripcion_msg: "",
      response: {},
      serverorigen: "",
      model: {
        //Dafaults Values
        drop_database: 0,
        server1: "",
        num_server: this.server1,
        srv_app_updt: 'synagro0.dnsalias.com',
        habilita_tesoreria: 1,
        fecha_liberacion: "",
        schema_name: "",
        habilita_db_solo_lectura: 0,
        serverorigen: "",
        file_name_tar: "",
        file_name_bkp: "",
        server_name: "",
        empresa: "TS",
        habilita_campo: "N",
        habilita_contabilidad: "N",
        habilita_construccion: "N",
        habilita_sueldo: 0,
        habilita_mobile: 0
      }
    };
  },
  mounted() {
    this.login();
    this.fetchServers();
    this.fetchDbTipos();
    this.fetchDbZonas();
    this.fetchAplicacionTipos();
    console.log(this);
    
  },

  methods: {
      login(){
        let token = TokenService.getToken()
        this.$http.post(this.backendURL + 'api/v1.0/checkSession/', {headers: {'Authorization': 'Token ' + token}})
        .then(() => {
          console.log("Token Correcto")
        })
        .catch(err => {
          // catch error});
          if(err.request.statusText == 'Unauthorized'){
            alert("Su sesion ha expirado...")
            this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login')
            })
          }
          else {
            console.log(err.data)
          }
        })
      },
    onSubmit(){
      // Valida si hay algun field invalido
      var forms = document.getElementById('formID');
      if (forms.getElementsByClassName('is-invalid').length > 0) {
        console.log("Corrija los errores del formulario")
        return
      }
      this.loading = true
      // Asigamos fecha de alta al modelo
      let creacion_date = new Date()
      this.model['fecha_creacion'] = creacion_date.getFullYear() + "-" + (Number(creacion_date.getMonth()) + 1) + "-" + creacion_date.getDate()    

      //busca y asocia el num_server de la lista de servidores con el modelo
      for(var servidor in this.servidores){
        if(this.servidores[servidor].value == this.model.server_name){
          this.model.num_server = this.servidores[servidor].num_server
          this.model.puerto = this.servidores[servidor].puerto
          // asignamos a demas campos de servidores el mismo valor que servidor
          this.model.server1 = this.servidores[servidor].host
          this.model.server2 = this.servidores[servidor].host
          this.model.server3 = this.servidores[servidor].host
          this.model.server4 = this.servidores[servidor].host
          this.model.server5 = this.servidores[servidor].host
          this.model.server6 = this.servidores[servidor].host
          this.model.server7 = this.servidores[servidor].host
          this.model.server1_central = this.servidores[servidor].host
          this.model.server2_central = this.servidores[servidor].host
          //manda id de mysql
          this.model.server_id = this.servidores[servidor].server_id
          break;
        }
      }

      // envia el post
      this.$http.post(this.backendURL + 'api/v1.0/restauracion_base/', this.model)
      .then(res => {
          // do something with res
          console.log(res.data);
          this.response = res.data
          this.loading = false
          if(this.response.msg.includes("ok")){
            this.showOkAlta = true
          }
          else {
            this.showErrorAlta = true;
          }
      })
      .catch(err => {
          // catch error});
          console.log(err.data)
          this.response = err.data
          this.loading = false;
          this.showErrorAlta = true;
          this.catchError(err)
      })
      
    },

    fetchServers() {
      let url = this.backendURL + 'api/v1.0/MySQL/';
      this.$http.get(url)
      .then( result => {
        console.log(result.data)
        for(var i in result.data){
          this.servidores.push({value: result.data[i].name, num_server: result.data[i].server.cod_server, text: result.data[i].name, puerto: result.data[i].port, server_id: result.data[i].server.id, host: result.data[i].server.host})
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchDbTipos(){
      let url = this.backendURL + 'api/v1.0/DbTipos/';
      this.$http.get(url)
      .then( result => {
        console.log(result.data)
        for(var i in result.data){
          this.db_tipo_id.push({value: result.data[i].id, text: result.data[i].nombre})
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchDbZonas(){
      let url = this.backendURL + 'api/v1.0/ZonasEmpresas/';
      this.$http.get(url)
      .then( result => {
        console.log(result.data)
        for(var i in result.data){
          this.zonas.push(result.data[i].zona)
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchAplicacionTipos() {
      let url = this.backendURL + 'api/v1.0/AplicacionTipos/';
      this.$http.get(url)
      .then( result => {
        console.log(result.data)
        for(var i in result.data){
          this.aplicacion_tipos.push({value: result.data[i].aplicacion_tipos_id, text: result.data[i].aplicacion_tipo})
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetch_tar_list() {
      for(var servidor in this.servidores){
        if(this.servidores[servidor].value == this.serverorigen){
          console.log("Host: " + this.servidores[servidor].host)
          this.model.serverorigen = this.servidores[servidor].host
          break;
        }
      }
      this.tar_list = [];
      this.$http.post(this.backendURL + 'api/v1.0/backups_tar_list/', this.model)
      .then( result => {
        for(var i in result.data){
          this.tar_list.push(result.data[i])
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetch_file_list() {
      console.log(this.model)
      this.file_list = [];
      this.$http.post(this.backendURL + 'api/v1.0/backups_file_list/', this.model)
      .then( result => {
        for(var i in result.data){
          this.file_list.push(result.data[i])
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },
  
    checkDatabaseName(kword){
      this.$http.get(this.backendURL + 'api/v1.0/Bases/?kword='+kword)
      .then(res => {
          if(res.data.length > 0 && !this.pisar_base){
            console.log(this.pisar_base)
            this.schemaname_isvalid = false
            this.schemaname_msg = "El nombre de la base de datos ya existe"
          }
          else if(res.data.length > 0 && this.pisar_base){
            this.schemaname_isvalid = true
            this.schemaname_msg = "La copia pisara la base existente. La descripcion mantendra la misma que la original. Los demas datos se actualizaran segun este formulario"
          }
          else if(this.schema_name.length > 25 || this.schema_name.length < 5){
              this.schemaname_isvalid = false
              this.schemaname_msg = "El nombre de la base de datos debe tener entre 5 y 25 caracteres"
          }
          
          else{
            this.modelos['schema_name'] = this.schema_name
            this.schemaname_isvalid = true
            this.schemaname_msg = "El nombre tecnico es correcto"
            this.pisar_base = false
          }            
            
      })
      .catch(err => {
          // catch error});
          this.catchError(err)
      })
    },
    checkDatabaseDescripcion(kword){
      this.$http.get(this.backendURL + 'api/v1.0/Descripcion/?kword='+kword)
      .then(res => {
          if(res.data.length > 0){
            this.descripcion_isvalid = false
            this.descripcion_msg = "La descripcion ya existe"
          }
          else if(this.model.descripcion.length < 5){
              this.descripcion_isvalid = false
              this.descripcion_msg = "Descripcion debe ser mayor a 5 caracteres"
          }
          else{
            this.descripcion_isvalid = true;
          }            
            
      })
      .catch(err => {
          // catch error});
          this.this.catchError(err)
      })
    },
    
    catchError(err){
      if(err.request.statusText == 'Unauthorized'){
        alert("Su sesion ha expirado...")
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
      else {
        console.log(err.data)
      }
    }
  },

  computed: {
    validation() {
        return this.schemaname_isvalid
      },
    validation2() {
        return this.descripcion_isvalid
      },
    schema_name(){
      return this.model.schema_name;
    },
    descripcion(){
      return this.model.descripcion;
    },
    servidororigen(){
      return this.serverorigen;
    },
    tarfile(){
      return this.model.file_name_tar;
    }
  },

  watch: {
    schema_name(val){
      console.log(val)
      this.checkDatabaseName(val)
    },
    descripcion(val){
      console.log(val)
      this.checkDatabaseDescripcion(val)
    },

    servidororigen(val){
      console.log(val)
      this.fetch_tar_list(val)
    },

    tarfile(val){
      this.fetch_file_list(val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 25px 0;
}

#formID{
  padding: 20px;
}
</style>
